import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clean the hash immediately so a refresh doesn't retry
    if (window.history.replaceState) {
      window.history.replaceState(null, "", window.location.pathname);
    }

    if (!sessionId) {
      toast.error("Oturum kimliği bulunamadı");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        await refresh();
        toast.success("Google ile giriş yapıldı");
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 gap-4">
      <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
      <div className="text-xs uppercase tracking-widest text-slate-400 font-mono">
        Oturum doğrulanıyor…
      </div>
    </div>
  );
}
